@if ((funding?.type === 'YOUNITED' || funding?.type === 'COFIDIS') && commercialProposal) {
    <div class="accordion">
        <details class="accordion-item" [ngClass]="isActive ? 'is-active' : ''" (click)="toggleAccordion()">
            <summary class="accordion-header">
                <h2 class="has-text-weight-semibold is-tertiary">Mentions légales du financement</h2>
            </summary>
            <div class="accordion-body has-text-left">
                <p class="has-text-weight-semibold text is-level-1">
                    Un crédit vous engage et doit être remboursé. Vérifier vos capacités de remboursement avant de vous
                    engager.
                </p>
                <p class="text is-level-2" [innerHTML]="dynamicData"></p>
                @if (funding.type === 'YOUNITED') {
                    <p class="text is-level-2">
                        Younited est agréé en tant qu'établissement de crédit - Prestataire de Services d’investissement
                        par l’Autorité de Contrôle Prudentiel et de Résolution (ACPR, n° d’agrément : 16488). Le
                        financement est accordé sous réserve d’acceptation définitive après l'étude de votre dossier.
                        Vous disposez d’un droit de rétractation de 14 jours calendaires révolus à compter de la
                        signature de l’offre de contrat de crédit.
                    </p>
                    <p class="text is-level-2">
                        Younited : SA à Directoire et Conseil de Surveillance au capital de 2 000 785&nbsp;€ - Siège
                        social : 21 rue de Châteaudun - 75009 PARIS - RCS de Paris 517586376 - Numero ORIAS 11061269
                    </p>
                } @else {
                    <p class="text is-level-2">
                        COFIDIS est agréé en tant qu’établissement de crédit par l'Autorité de Contrôle Prudentiel et de
                        Résolution (ACPR, n° d’agrément : 14940), 4, place de Budapest – CS 92459 –75436 Paris CEDEX 09.
                    </p>
                    <p class="text is-level-2">
                        Le financement est accordé sous réserve d'acceptation définitive après l'étude de votre dossier.
                        Vous disposez d'un droit de rétractation de 14 jours calendaires révolus à compter de la
                        signature de l'offre de contrat de crédit.
                    </p>
                    <p class="text is-level-2">
                        COFIDIS : Société Anonyme à Directoire et Conseil de surveillance au capital de 67 500
                        000&nbsp;€ – Siège social : Parc de la Haute Borne, 61 avenue Halley, 59866 Villeneuve d'Ascq –
                        RCS Lille Métropole 325307106
                    </p>
                }
            </div>
        </details>
    </div>
}
